import m from "./../../../dist/es2015/locales/ru_RU.js";
export const am5locales_ru_RU = m;